export enum UserRole {
  // Helper users that collect information in some location
  Prisspotter = 1,
  // Users that substitute somebody during vacation
  Ferieafloeser = 2,
  // User with full rights
  DistrictPartner = 3,
}
